{
  "tabs": {
    "chat": "Kukambirana",
    "reminders": "Zikumbutso",
    "calendar": "Kalendala",
    "settings": "Zikhazikiko"
  },
  "common": {
    "cancel": "Lekani",
    "save": "Sungani",
    "confirm": "Tsimikizani",
    "delete": "Chotsani",
    "back": "Bwerera",
    "close": "Tsekani",
    "edit": "Sintha",
    "search": "Sakani",
    "all": "Zonse",
    "loading": "Kukweza...",
    "error": "Chinthu chinachitika cholakwika",
    "notFound": "Sinalembedwe",
    "tryAgain": "Chonde yesani kachiwiri",
    "retry": "Yesani kachiwiri",
    "undo": "Bwezeretsani",
    "pullToRefresh": "Kokani kuti musinthe",
    "justNow": "pamenepa"
  },
  "auth": {
    "welcome": "Takulandirani ku FishMemory",
    "tagline": "Wothandizira wanu wa zikumbutso za WhatsApp, tsopano m'bokosi lanu.",
    "subtitle": "Wothandizira wanu wa zikumbutso za WhatsApp, tsopano m'bokosi lanu.",
    "phoneLabel": "Nambala yanu ya WhatsApp",
    "phoneHint": "Tidzakutumizirani nambala yotsimikizira pa WhatsApp",
    "invalidPhone": "Chonde lowetsani nambala yachilendo",
    "continue": "Pitirizani",
    "enterPhone": "Lowetsani nambala yanu ya WhatsApp",
    "phonePlaceholder": "Nambala yafoni",
    "sendCode": "Tumizani Nambala",
    "verifyTitle": "Tsimikizani nambala yanu",
    "otpSentTo": "Nambala ya manambala 6 yatumizidwa ku {{phone}} pa WhatsApp",
    "enterFullCode": "Chonde lowetsani manambala onse 6",
    "invalidOtp": "Nambala si yolondola. Chonde yesani kachiwiri.",
    "otpFailed": "Kutumiza nambala kwalephera. Yesani kachiwiri.",
    "otpResent": "Nambala yatumizidwanso",
    "resendIn": "Tumizani kachiwiri mu {{seconds}}s",
    "resendCode": "Tumizani nambala kachiwiri",
    "enterOtp": "Lowetsani nambala yomwe yatumizidwa ku WhatsApp yanu",
    "verify": "Tsimikizani",
    "resend": "Tumizani nambala kachiwiri",
    "wrongNumber": "Nambala yolakwika?",
    "backToPhone": "Bwerera ku foni",
    "editPhone": "Sintha nambala yafoni",
    "error": "Cholakwika",
    "setupTitle": "Tiyeni tiyambe",
    "setupSubtitle": "Mutha kusintha izi nthawi iliyonse mu Zikhazikiko",
    "namePlaceholder": "Dzina lanu",
    "letsGo": "Malizitsani kukonza",
    "skipForNow": "Siyani pano"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Lembani uthenga...",
    "inputPlaceholder": "Lembani uthenga...",
    "typing": "FishMemory ikulemba...",
    "online": "Pa intaneti",
    "connecting": "Kugwirizana...",
    "reconnecting": "Kugwirizananso...",
    "offline": "Sali pa intaneti",
    "empty": "Yambani kukambirana",
    "emptyHint": "Pangani zikumbutso, onani dongosolo lanu, kapena funsani thandizo.",
    "emptyAction": "Tumizani zikumbutso zoyeserera",
    "actions": "Zochita pa kukambirana",
    "keep": "Sungani mauthenga",
    "clearTitle": "Fufuzani kukambirana",
    "clearConfirm": "Chotsani mauthenga onse pa chipangizo ichi? Sizitha kubwezeretsedwa.",
    "clear": "Fufuzani kukambirana",
    "optionSelected": "Yasankhidwa: {{label}}",
    "sendingSelection": "Kutumiza...",
    "connectionLost": "Kugwirizananso..."
  },
  "reminders": {
    "title": "Zikumbutso Zanga",
    "active": "Zikugwira ntchito",
    "today": "Lero",
    "thisWeek": "Sabata ino",
    "history": "Mbiri",
    "items": "zinthu",
    "emptyTitle": "Palibe zikumbutso mpaka pano",
    "emptySubtitle": "Pangani chimodzi kuchokera pa kukambirana ndipo chidzawonekera pano.",
    "emptyAction": "Tsegulani kukambirana",
    "filterActive": "Zikugwira ntchito",
    "filterToday": "Lero",
    "filterWeek": "Sabata ino",
    "filterHistory": "Mbiri",
    "emptyState": "Palibe zikumbutso mpaka pano. Yambani kukambirana!",
    "swipeDone": "Zachitika",
    "swipeSnooze": "Sungani nthawi",
    "swipeDelete": "Chotsani",
    "search": "Sakani zikumbutso...",
    "upcoming": "Zikubwera",
    "completed": "Zachitika",
    "overdue": "Zasowa nthawi",
    "tomorrow": "Mawa",
    "synced": "Zikugwirizana {{value}}",
    "swipeHint": "Sewani zikumbutso kuti muwone zochita zina",
    "noResults": "Palibe zikumbutso zomwe zikugwirizana ndi kufufuza kwanu",
    "noResultsHint": "Yesani mawu ena kapena fufuzani kufufuza",
    "deleteAllFailed": "Kutaya zikumbutso zonse kwalephera"
  },
  "calendar": {
    "title": "Kalendala",
    "today": "Lero",
    "tomorrow": "Mawa",
    "completed": "Zachitika",
    "noEvents": "Palibe zochitika",
    "noEventsSubtitle": "Sankhani tsiku kuti muwone zikumbutso ndi zochitika za kalendala.",
    "googleEvent": "Kalendala ya Google",
    "legendActive": "Zikugwira ntchito",
    "legendRecurring": "Zimabwerezedwa",
    "legendDone": "Zachitika",
    "legendGoogle": "Google",
    "previousMonth": "Mwezi wapitawo",
    "nextMonth": "Mwezi wotsatira",
    "previousYear": "Chaka chapitacho",
    "nextYear": "Chaka chatsopano",
    "goToToday": "Pitani lero",
    "all": "Zonse",
    "active": "Zikugwira ntchito",
    "done": "Zachitika",
    "paused": "Zimayimiridwa"
  },
  "settings": {
    "title": "Zikhazikiko",
    "profile": "Mbiri",
    "name": "Dzina looneka",
    "enterName": "Lowetsani dzina lanu",
    "language": "Chilankhulo",
    "uiLanguage": "Chilankhulo cha pulogalamu",
    "uiLanguageHelp": "Imasinthira mawonekedwe a pulogalamu, mawu a kalendala, ndi njira ya mawonekedwe pa chipangizo ichi chokha.",
    "serverLanguage": "Chilankhulo cha kukambirana",
    "serverLanguageHelp": "Imasinthira chilankhulo chomwe seva imagwiritsa ntchito kuyankha ndi mauthenga a zikumbutso pa akaunti yanu.",
    "timezone": "Nthawi ya dera",
    "currentTimezone": "Nthawi ya dera yomwe ikugwiritsidwa ntchito",
    "timezoneHelp": "Nthawi zonse za zikumbutso zionetsedwa pogwiritsa ntchito nthawi iyi ya dera.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Sungani nthawi ya dera",
    "timezoneSaved": "Nthawi ya dera yasinthidwa",
    "detect": "Dziwani",
    "detectFailed": "Sinathe kudziwa nthawi ya dera",
    "autoDetect": "Dziwani zokha kuchokera ku GPS",
    "notifications": "Zidziwitso",
    "notificationsHelp": "Zikumbutso zotsatira zimayang'anira zidziwitso zomwe zimabwerezedwa pambuyo pa zikumbutso. Mvulayi ya zidziwitso pa chipangizo imayang'aniridwa mu zikhazikiko za foni yanu.",
    "pushEnabled": "Zidziwitso Zopushira",
    "autoDoneOnFire": "Marka zokha ngati zachitika",
    "autoDoneOnFireDesc": "Ngati sizikugwira ntchito, zikumbutso zikhala zikugwira ntchito mpaka mutazimarka ngati zachitika.",
    "googleCalendar": "Kalendala ya Google",
    "google": "Kalendala ya Google",
    "googleConnected": "Zalumikizidwa",
    "googleDisconnected": "Sinalumikizidwe",
    "googleConnectedHelp": "Zikumbutso zatsopano zitha kusinthidwa ku kalendala yanu zokha.",
    "googleDisconnectedHelp": "Lumikizani Kalendala ya Google kuti zikumbutso ndi zochitika zizikhala zogwirizana.",
    "googleConnectFailed": "Kutheka kulumikiza Kalendala ya Google kwalephera",
    "connected": "Zalumikizidwa",
    "disconnected": "Sinalumikizidwe",
    "connect": "Lumikizani",
    "disconnect": "Chotsani kulumikizana",
    "autoSync": "Sinthani zokha zikumbutso zatsopano",
    "autosync": "Sinthani zokha zikumbutso zatsopano",
    "subscription": "Kulembetsa",
    "trialUsed": "Mayeso: {{used}}/{{total}} agwiritsidwa ntchito",
    "trialStatus": "Mayeso alipo",
    "activeStatus": "Kulembetsa kogwira ntchito",
    "expiredStatus": "Kulembetsa kwatha",
    "unsubscribedStatus": "Sinalembetse",
    "about": "Zambiri",
    "version": "Mtundu",
    "logout": "Tulutsani",
    "logoutTitle": "Tulutsani",
    "logoutConfirm": "Kodi mukufuna kutuluka?",
    "noName": "Palibe dzina lomwe linasankhidwa",
    "serverConnection": "Kulumikizana kwa seva",
    "serverUrl": "URL ya seva",
    "serverEdit": "Sintha",
    "saveReconnect": "Sungani ndi kulumikizanso",
    "resetDefault": "Bwezeretsani mwachizolowezi",
    "invalidServerUrlTitle": "URL ya seva si yolondola",
    "invalidServerUrlMessage": "Lowetsani URL ya seva yolondola ya http kapena https, mwachitsanzo https://example.com",
    "uiLanguageChangeFailed": "Kusinthira chilankhulo cha pulogalamu kwalephera. Chonde yesani kachiwiri.",
    "serverLanguageChangeFailed": "Kusinthira chilankhulo cha kukambirana kwalephera. Chonde yesani kachiwiri.",
    "timezoneChangeFailed": "Kusinthira nthawi ya dera kwalephera. Chonde yesani kachiwiri.",
    "autoSyncChangeFailed": "Kusintha auto-sync kwalephera. Chonde yesani kachiwiri.",
    "nameChangeFailed": "Kusintha dzina looneka kwalephera. Chonde yesani kachiwiri.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Zambiri za zikumbutso",
    "editTime": "Sintha Nthawi",
    "rename": "Sintha Dzina",
    "snooze": "Sungani Nthawi",
    "snooze15": "Sungani mphindi 15",
    "pause": "Imani",
    "pauseReminder": "Imani zikumbutso",
    "resume": "Bwezeretsani",
    "resumeReminder": "Bwezeretsani zikumbutso",
    "skip": "Siyani yotsatira",
    "skipOccurrence": "Siyani nthawi ino",
    "syncGoogle": "Sinthani ku Google",
    "delete": "Chotsani",
    "deleteTitle": "Chotsani Zikumbutso",
    "deleteConfirm": "Zikumbutsozi zidzachotsedwa kwathunthu.",
    "deleteRecurringTitle": "Chotsani Zikumbutso Zobwerezedwa",
    "deleteRecurringMessage": "Kodi mukufuna kusiyira nthawi ino kapena kuchotsa mndandanda wonse?",
    "deleteThisOccurrence": "Siyani nthawi ino",
    "deleteEntireSeries": "Chotsani mndandanda wonse",
    "done": "Zachitika",
    "markDone": "Marka ngati zachitika",
    "undo": "Bwezeretsani",
    "undoPrompt": "Mukufuna kuti ikhale yogwira ntchito kachiwiri? Bwezeretsani tsopano.",
    "recurring": "Zobwerezedwa",
    "nextRun": "Nthawi yotsatira",
    "oneTime": "Kawiri kokha",
    "pending": "Ikuyembekezeka",
    "sent": "Yatumizidwa",
    "paused": "Yimidwa",
    "active": "Ikugwira ntchito",
    "snoozed": "Yasungidwa",
    "localTime": "Zionetsedwa nthawi yanu ya m'deralo",
    "recurrence": "Kubwerezedwa",
    "created": "Yapangidwa",
    "tags": "Ma tag",
    "fireCount": "Nthawi zomwe zikuchitika",
    "actions": "Zochita",
    "none": "Palibe",
    "snoozeFailed": "Kusunga nthawi kwalephera",
    "pauseFailed": "Kuyimitsa zikumbutso kwalephera",
    "resumeFailed": "Kubwezeretsa zikumbutso kwalephera",
    "skipFailed": "Kusiya zikumbutso kwalephera",
    "doneFailed": "Kumarka zikumbutso ngati zachitika kwalephera",
    "undoFailed": "Kubwezeretsa chikhalidwe cha zikumbutso kwalephera",
    "deleteFailed": "Kutaya zikumbutso kwalephera",
    "rescheduleTitle": "Kusintha nthawi?",
    "rescheduleMsg": "Zikumbutsozi zasowa nthawi. Kodi mukufuna kusintha nthawi yake?",
    "reschedule15": "Mphindi 15 zikubwerazi",
    "reschedule60": "Mphindi 60 zikubwerazi",
    "keepOverdue": "Sungani momwe zilili"
  },
  "onboarding": {
    "slide1Title": "Takulandirani ku FishMemory",
    "slide1Sub": "Wothandizira wanu wa zikumbutso — amagwiritsa ntchito WhatsApp ndipo wapangidwa kuti ugwire ntchito m'bokosi lanu.",
    "slide2Title": "Kukambirana Mwachilengedwe",
    "slide2Sub": "Lembani zikumbutso momwe mumaganizira: \"Kumbutsani kundifonera amayi mawa pa 3pm\" — ife timachita zina zonse.",
    "slide3Title": "Osaphonya Chilichonse",
    "slide3Sub": "Pezani zidziwitso nthawi yake, konzekerani ndi ma tag, ndipo khalani patsogolo pa zonse zofunika.",
    "getStarted": "Yambani",
    "next": "Kenako",
    "firstReminderTitle": "Pangani zikumbutso choyamba!",
    "firstReminderHint": "Yesani kulemba chinthu ngati:",
    "firstReminderExample": "Kumbutsani kundumwa madzi mawa pa 9 AM",
    "gotIt": "Ndazindikira!",
    "notifRationaleTitle": "Khalani pa Nthawi",
    "notifRationaleBody": "FishMemory imafunikira zidziwitso kuti ikumbutse nthawi yake. Mudzapeza zidziwitso zokha za zikumbutso zomwe mumapanga.",
    "notifRationaleAllow": "Yambitsani Zidziwitso",
    "notifRationaleLater": "Mwinanso Kenako",
    "swipeHint": "Sewani kumanja kuti muwone zochita mwachangu →",
    "calendarDragHint": "Kokani kuti muwonjezere ↕"
  }
}
